<!-- APP--APP管理--流量配置 -->
<template>
  <div class="md-layout">
    <!-- 表单 -->
    <div class="md-layout-item md-layout mx-auto md-size-70 md-medium-size-100">
      <!-- 移远(单选框) -->
      <label class="md-layout-item md-size-20 md-form-label">{{$I18n("quectel")}}:</label>
      <div class="md-layout-item md-small-size-100">
        <md-field>
          <md-select v-model="form">
            <md-option value="">{{$I18n("dont_bind")}}</md-option>
            <md-option v-for="item in data.filter(i => i.type == 1)" :key="item.id" :value="item.id">{{item.name}}</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div class="md-layout-item md-layout mx-auto md-size-70 md-medium-size-100">
      <!-- 移远(单选框) -->
      <label class="md-layout-item md-size-20 md-form-label">{{$I18n("dxy")}}:</label>
      <div class="md-layout-item md-small-size-100">
        <md-field>
          <md-select v-model="dxy">
            <md-option value="">{{$I18n("dont_bind")}}</md-option>
            <md-option v-for="item in data.filter(i => i.type == 2)" :key="item.id" :value="item.id">{{item.name}}</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <!-- 表单-提交按钮 -->
    <div class="md-layout-item mx-auto md-size-70 md-medium-size-100">
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <!-- 弹窗 -->
    <modal key="main" v-show="modal" @close="modal_closeModal" class="lg-modal">
      <!-- 弹窗-头部 -->
      <template slot="header">
        <h4 class="modal-title">{{$I18n("tips")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_closeModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <!-- 弹窗-主体 -->
      <template slot="body">
        <div>{{$I18n("is_sure_edit")}}</div>
      </template>
      <!-- 弹窗-底部按钮 -->
      <template slot="footer">
        <md-button @click="modal_submit" class="left-icon md-info">{{$I18n("sure")}}</md-button>
        <md-button @click="modal_closeModal" class="">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Modal } from '@/components';
export default {
  components: {
    Modal,
  },
  props: {
    app_id : {
      type: String,
      default: "",
    },
 },
  data(){
    return {
      modal: false, // 弹窗是否打开了
      form : "",    // (移远)已选择的选项
      dxy : "",
      data : [],    // 全部的第三方类型
    }
  },
  methods: {
    modal_openModal (){ // 弹窗-打开弹窗
      this.modal = true;
    },
    modal_closeModal(){ // 弹窗-关闭弹窗
      this.modal = false;
    },
    modal_submit(){ // 弹窗-提交修改
      let platform_id = [];
      if(this.form) {
        platform_id.push(this.form);
      }
      if(this.dxy){
        platform_id.push(this.dxy)
      }
      this.$api.bindAppOtherPlatform({ 
        app_id : this.app_id,
        platform_id ,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.modal_closeModal();
          this.api_getFlow();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    api_getFlow(){ // API-获取对应 "APP ID" 绑定的(移远)第三方
      this.form = ""
      return this.$api.getAppOtherPlatformBind({
        app_id: this.app_id,
      })
        .then(this.$Then(res => {
          let flow = res.data.filter(item => {
            return item.type == 1;
          });
          if(flow.length > 0){
            this.form = flow[0].platform_id;
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.form = "";
        }))
    },
    api_getAllPlatform(){ // API-获取所有的第三方平台
      return this.$api.getOtherPlatformInfo({})
        .then(this.$Then(res => {
          this.data = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.data = [];
        }))
    },
  },
  created(){
    this.api_getAllPlatform()
      .then(() => {
        if(this.app_id){
          this.api_getFlow()
        }
      })
  },
}
</script>